// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverRelaySlot {
	slot: string | undefined;

	number: number;

	name: string | undefined;

	snoozable: boolean;

	pulseSeconds: number;

	$type?: string | undefined;
}
export class DriverRelaySlot {
	constructor(data?: IDriverRelaySlot) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	slot: string | undefined;

	number: number = 0;

	name: string | undefined;

	snoozable: boolean = false;

	pulseSeconds: number = 0;

	static $type: string = "CoreApi.Models.DriverRelaySlot, ";
	$type?: string | undefined = DriverRelaySlot.$type;
}

